/* eslint-disable max-len */
import React, { ReactNode } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import auth from 'utils/auth';
import MobileMoney from 'components/modules/MobileMoney/MobileMoney';
import withLayout, { AuthScreenType, AuthScreenWrapper, MenuWrapper, SupportWrapper } from 'components/layouts';
import DashboardPage from 'components/Dashboard/DashboardPage';
import FAQs from 'components/modules/FAQs/FAQs';
import Complaint from 'components/modules/Complaint/Complaint';
import LogIn from 'components/authModules/LogIn/LogIn';
import ChangePassword from 'components/authModules/ChangePassword/ChangePassword';
import ForgotPassword from 'components/authModules/ForgotPassword/ForgotPassword';
import ResetPassword from 'components/authModules/ForgotPassword/ResetPassword/Resetpassword';
import PendingRequest from 'components/modules/PendingRequest/PendingRequests';
import PrivacyPolicy from 'components/modules/PrivacyPolicy&TermsOfService/PrivacyPolicy/PrivacyPolicy';
import RegulatoryDirectives from 'components/modules/PrivacyPolicy&TermsOfService/Regulatory Directives/RegulatoryDirectives';
import Transfers from 'components/modules/Transfers/Transfers';
import Beneficiaries from 'components/modules/Beneficiaries/Beneficiaries';
import PrepaidCardLoad from 'components/modules/PrepaidCardLoad/PrepaidCard';
import BankStatement from 'components/modules/BankStatement/BankStatement';
import ScheduledTransfers from 'components/modules/ScheduledTransfers/ScheduledTransfers';
import FxTransferAndRates from 'components/modules/FxTransferRequest/FxTransfer';
import MyRequest from 'components/modules/MyRequest/MyRequests';
import BillPayments from 'components/modules/BillsPayment/BillPayments';
import ContactUs from 'components/modules/ContactUs/ContactUs';
import TransactionReport from 'components/modules/TransactionReport/TransactionReport';
import NoAccessPage from 'components/modals/NoAccessPage/NoAccessPage';
import routePaths from './routePaths';

const noAccessPage = withLayout(MenuWrapper, null)(NoAccessPage);

const getRoutes = (authenticated: boolean): ReactNode => (
  <Switch>
    <Route path={routePaths.login} component={withLayout(AuthScreenWrapper, { type: AuthScreenType.login })(LogIn)} />
    <Route path={routePaths.dashboard} component={withLayout(MenuWrapper, null)(DashboardPage)} />
    <Route
      path={routePaths.transfer}
      component={
        auth.permissions.transfers
          ? withLayout(MenuWrapper, null)(Transfers)
          : noAccessPage
      }
    />
    <Route
      path={routePaths.billPayments}
      component={
        auth.permissions.billPayments
          ? withLayout(MenuWrapper, null)(BillPayments)
          : noAccessPage
      }
    />
    <Route
      path={routePaths.beneficiaries}
      component={
        auth.permissions.beneficiaries
          ? withLayout(MenuWrapper, null)(Beneficiaries)
          : noAccessPage
      }
    />
    <Route
      path={routePaths.prepaidCardLoad}
      component={
        // auth.modifiedPermission.includes(permissionMapping['Prepaid Card Load'])
        auth.permissions.prepaidCardLoad
          ? withLayout(MenuWrapper, null)(PrepaidCardLoad)
          // : withLayout(MenuWrapper, null)(DashboardPage)
          : noAccessPage
      }
    />
    <Route
      path={routePaths.bankStatement}
      component={
        auth.permissions.bankStatements
          ? withLayout(MenuWrapper, null)(BankStatement)
          : noAccessPage
      }
    />
    <Route
      path={routePaths.myRequests}
      component={
        auth.permissions.myRequests
          ? withLayout(MenuWrapper, null)(MyRequest)
          : noAccessPage
      }
    />
    <Route
      path={routePaths.scheduleTransfers}
      component={
        auth.permissions.scheduleTransfers
          ? withLayout(MenuWrapper, null)(ScheduledTransfers)
          : noAccessPage
      }
    />
    <Route
      path={routePaths.fxTransferRates}
      component={
        auth.permissions.fxTransferRate
          ? withLayout(MenuWrapper, null)(FxTransferAndRates)
          : noAccessPage
      }
    />
    <Route
      path={routePaths.transactionReport}
      component={
        auth.permissions.transactionReports
          ? withLayout(MenuWrapper, null)(TransactionReport)
          : noAccessPage
      }
    />
    <Route
      path={routePaths.mobileMoney}
      component={
        auth.permissions.mobileMoney
          ? withLayout(MenuWrapper, null)(MobileMoney)
          : noAccessPage
      }
    />
    <Route
      path={routePaths.pendingRequests}
      component={
        auth.permissions.pendingRequests
          ? withLayout(MenuWrapper, null)(PendingRequest)
          : noAccessPage
      }
    />
    <Route path={routePaths.login} component={withLayout(AuthScreenWrapper, { type: AuthScreenType.login })(LogIn)} />
    <Route
      path={routePaths.changePassword}
      component={withLayout(AuthScreenWrapper, { type: AuthScreenType.login })(ChangePassword)}
    />
    <Route
      path={routePaths.forgotPassword}
      component={withLayout(AuthScreenWrapper, { type: AuthScreenType.login })(ForgotPassword)}
    />
    <Route
      path={routePaths.resetPassword}
      component={withLayout(AuthScreenWrapper, { type: AuthScreenType.login })(ResetPassword)}
    />
    <Route path={routePaths.contactUs} component={withLayout(SupportWrapper, null)(ContactUs)} />
    <Route path={routePaths.faq} component={withLayout(SupportWrapper, null)(FAQs)} />
    <Route path={routePaths.complaint} component={withLayout(SupportWrapper, null)(Complaint)} />
    <Route path={routePaths.privacyPolicy} component={withLayout(SupportWrapper, null)(PrivacyPolicy)} />
    <Route path={routePaths.regulatoryDirectives} component={withLayout(SupportWrapper, null)(RegulatoryDirectives)} />
    <Route exact path="/">
      {authenticated ? <Redirect to={routePaths.dashboard} /> : <Redirect to={routePaths.login} />}
    </Route>
  </Switch>
);

export default getRoutes;
